import { render, staticRenderFns } from "./GroupDeleteConfirmation.vue?vue&type=template&id=6bc60ce0&"
import script from "./GroupDeleteConfirmation.vue?vue&type=script&lang=ts&"
export * from "./GroupDeleteConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports